import { Component, Input, OnInit, inject } from '@angular/core';
import { CallService, SmsService, StudentInfo, StudentService } from '../../lib';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-student-detail',
  templateUrl: './student-detail.component.html'
})
export class StudentDetailComponent  implements OnInit {
	toastService = inject(ToastService);
  studentId: number | undefined;
  @Input() student: StudentInfo | null = null;

  constructor(private route: ActivatedRoute, private studentService: StudentService,private smsService: SmsService, private callService: CallService) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.studentId = params['id'];
      if(!this.studentId) return;
      this.studentService.apiStudentPost({syStudentId: this.studentId}).subscribe({
        next: (response) => {
          if(response?.length > 0) {
            this.student = response[0];
          }
        },
        error: (error) => {
          console.error(error);
        }
      });
    });
  }
  checkCallCompliance(phone:string|null|undefined) {
    this.callService.apiCallCheckCompliancePost({phone: phone ?? ''}).subscribe({
      next: (response) => {
        if(response.canCall) {
          this.toastService.show({body: 'Call made to this student phone ' + phone,classname:'bg-success text-light', delay: 5000, header:'Call Success'})
        } else {
          this.toastService.show({body: 'Call cannot be made to this student phone ' + phone,classname:'bg-danger text-light', delay: 5000, header:'Call Failed'})
        }
      },
      error: (error) => {
        console.error(error);
      }
    });

  }
  checkSmsCompliance(phone:string|null|undefined) {
    this.smsService.apiSmsCheckCompliancePost({phone:phone}).subscribe({
      next: (response) => {
        if(response.canSend) {
          this.toastService.show({body: 'SMS can be sent to this student phone ' + phone,classname:'bg-success text-light', delay: 5000, header:'SMS Sent'})
        } else {
          this.toastService.show({body: 'SMS cannot be sent to this student phone ' + phone,classname:'bg-danger text-light', delay: 5000, header:'SMS Failed'})
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
}
